import * as React from 'react';
import S from './AuthorBlock.styles';
import { getSrcs } from '@helpers/image';
const AuthorBlock = ({ title, summary, image, name, role, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Summary, null, summary)),
            React.createElement(S.BaseWrapper, null,
                React.createElement(S.Name, { "data-is-link": name.url ? 'true' : 'false', as: name.url ? 'a' : 'span', target: name.target, href: name.url }, name.text),
                React.createElement(S.Role, null, role),
                React.createElement(S.MediaWrapper, null, image && (React.createElement(S.Image, { alt: image?.altText ?? '', loading: "lazy", role: image?.altText ? undefined : 'presentation', src: getSrcs(image, 360, 180, 2, 1)[0].split(' ')[0] })))))));
};
export default AuthorBlock;
